import { render, staticRenderFns } from "./sub.vue?vue&type=template&id=019692f1&scoped=true"
import script from "./sub.vue?vue&type=script&lang=ts"
export * from "./sub.vue?vue&type=script&lang=ts"
import style0 from "./sub.vue?vue&type=style&index=0&id=019692f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019692f1",
  null
  
)

export default component.exports